import { combineReducers } from 'redux';
// slices
 import accountInfoReducer from './slices/accountInfo/account-info';
 import quotesReducer from './slices/quotes/quotes';
 import globalCurrencyReducer from './slices/app-currency'; 
 import jwtReducer from './slices/auth/sep10'
 import walletInfoReducer from './slices/walletInfo/wallet';
 import delegateSigningReducer from './slices/delegate_signing/delegate-signing';
 import rawWalletInfoReducer from './slices/walletInfo/rawWalletInfo';
 import userReducer from './slices/user/user';
 import showTabsReducer from './slices/showTabs/showTabs';
 import languageReducer from './slices/language/language';
 import selectedAssetReducer from './slices/selected-asset/selected-asset';
 import operationHistoryReducer from './slices/operation-history-params/operationHistoryParams';
 import operationHistoryListReducer from './slices/operation-history-list/operationHistoryList';
 import paymentDestinationInfoReducer from './slices/paymentDestinationInfo/paymentDestinationInfo';
 
 import selectedTabReducer from './slices/selected-tab/selected-tab';
 import supportedAssetsReducer from './slices/supportedAssets/supportedAssets';
 import supportedPoolsReducer from './slices/supportedPools/supportedPools';
 import recoverServersReducer from './slices/recoverServers/recoverServers';
 import userContactsReducer from './slices/user-contacts/user-contacts';
 import pinReducer from './slices/pin/pin';
 import topUpContactReducer from './slices/topup_contact/topup_contact';
 import topUpProvidersReducer from './slices/topup_providers/topup_providers';
 import topUpProductReducer from './slices/topup_products/topup_product';
 import selectedTopUpProviderReducer from './slices/topup_provider_selected/selected_topup_provider';
 import giftCardProviderReducer from './slices/giftcards_providers/giftcards_providers';
 import giftCardProductsReducer from './slices/giftcards_products/giftcards_products';
 import selectedGiftCardProvider from './slices/giftcards_provider_selected/selected_giftcard_provider';
 import topupPricingReducer from './slices/topup_pricing/topup_pricing';
 import giftCardsPricingReducer from './slices/giftcards_pricing/giftcards_pricing';
 import openedSep7UriReducer from './slices/opened_sep7_scheme/opened_stellar_uri_scheme';
 import openedDisbursementUriReducer from './slices/opened_disbursement_uri/opened_disbursement_uri';
 import openedRootModalReducer from './slices/opened_navigation_modal/opened_root_modal';
 import themeReducer from './slices/theme/theme';
 import cryptoModeReducer from './slices/crypto_mode/crypto_mode';
 import balanceVisibilityReducer from './slices/balance-visibility/balance-visibility';
 import lockScreenReducer from './slices/lockScreen/lockScreen';
 import flowContextReducer from './slices/flow-context/flowContext';

 import CapacitorStorage from './redux-persist-capacitor';
 import { stellarApi } from '../api/stellar';
 import { ebioroApi } from '../api/ebioro/ebioro';
 import { recoveryServerApi } from '../api/recovery-servers/recovery.servers';
 import { coinGeckoApi } from '../api/coin-gecko/coingecko';
 import { moonPayClientApi } from '../api/moonpay/moonpay';

 //import {depositWithdrawApi} from '../api/deposit-withdraw/deposit-withdraw';

// ----------------------------------------------------------------------

const rootReducer = combineReducers({
  
  accountInfo:accountInfoReducer,
  quotes:quotesReducer,
  globalCurrency:globalCurrencyReducer,
  sep10AuthToken:jwtReducer,
  walletInfo:walletInfoReducer,
  user:userReducer,
  delegateSigning:delegateSigningReducer,
  rawWalletInfo:rawWalletInfoReducer,
  showTabs:showTabsReducer,
  language:languageReducer,
  selectedAsset:selectedAssetReducer,
  operationHistoryParams:operationHistoryReducer,
  operationHistoryList:operationHistoryListReducer,
  paymentDestinationInfo:paymentDestinationInfoReducer,
  selectedTab:selectedTabReducer,
  supportedAssets:supportedAssetsReducer, 
  supportedPools:supportedPoolsReducer,
  pin:pinReducer,
  recoverServers:recoverServersReducer,
  userContacts:userContactsReducer,
  topUpContact:topUpContactReducer,
  toUpProviders:topUpProvidersReducer,
  topUpProducts:topUpProductReducer,
  selectedTopUpProvider:selectedTopUpProviderReducer,
  giftCardProviders:giftCardProviderReducer,
  giftCardProducts:giftCardProductsReducer,
  selectedGiftCardProvider:selectedGiftCardProvider,
  topUpPricing:topupPricingReducer,
  giftCardsPricing:giftCardsPricingReducer,
  openedSep7Uri:openedSep7UriReducer,
  openedDisbursementUri:openedDisbursementUriReducer,
  openedRootModal:openedRootModalReducer,
  theme:themeReducer,
  cryptoMode:cryptoModeReducer,
  balanceVisibility:balanceVisibilityReducer,
  lockScreen:lockScreenReducer,
  flowContext:flowContextReducer,

  [stellarApi.reducerPath]:stellarApi.reducer,
  [ebioroApi.reducerPath]:ebioroApi.reducer,
  [recoveryServerApi.reducerPath]:recoveryServerApi.reducer,
  [coinGeckoApi.reducerPath]:coinGeckoApi.reducer,
  [moonPayClientApi.reducerPath]:moonPayClientApi.reducer
});

const rootPersistConfig = {
  key: 'root',
  storage:CapacitorStorage,
  keyPrefix: 'ebioro-wallet',
  whitelist: ["theme","cryptoMode","balanceVisibility","sep10AuthToken","accountInfo","user","language","selectedAsset","paymentDestinationInfo","supportedAssets","userContacts","openedSep7Uri","openedDisbursementUri","openedRootModal"],
};

export { rootPersistConfig, rootReducer };